import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { UrgencyBanner } from "@/components/UrgencyBanner";
import { HeroSection } from "@/components/HeroSection";
import InstantQuoteSection from "@/components/InstantQuoteSection";
import { TrustSignalsBar } from "@/components/TrustSignalsBar";
import { ZorgeloosSection } from "@/components/ZorgeloosSection";
import { LoxoneSmartHomeSection } from "@/components/LoxoneSmartHomeSection";
import { EnergyManagementSection } from "@/components/EnergyManagementSection";
import { ServicesSection } from "@/components/ServicesSection";
import { PartnersSection } from "@/components/PartnersSection";
import { CTASection } from "@/components/CTASection";
import EnergyContractsSection from "@/components/EnergyContractsSection";
import { ThermalStorageSection } from "@/components/ThermalStorageSection";
import { SEO } from "@/components/seo/SEO";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { CaseStudiesSection } from "@/components/CaseStudiesSection";
import { FloatingWhatsAppButton } from "@/components/mobile/FloatingWhatsAppButton";
import { MobileCTABar } from "@/components/mobile/MobileCTABar";
import { AudioPreviewSection } from "@/components/AudioPreviewSection";
import { LightingPreviewSection } from "@/components/LightingPreviewSection";
import { ClimatePreviewSection } from "@/components/ClimatePreviewSection";
import { useScrollTracking } from "@/hooks/useScrollTracking";
import heroImage from "@/assets/hero-solar.jpg";

const Index = () => {
  useScrollTracking();
  
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "SOL-VI",
    url: origin || "https://sol-vi.nl",
    logo: (origin || "") + "/favicon.ico",
  } as const;
  const website = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "SOL-VI",
    url: origin || "https://sol-vi.nl",
  } as const;
  const localBusiness = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "SOL-VI",
    url: origin || "https://sol-vi.nl",
    telephone: "+31617105786",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Prinswillemalexander straat",
      postalCode: "6661 XH",
      addressLocality: "Elst",
      addressCountry: "NL",
    },
    areaServed: "Regio Arnhem-Nijmegen",
  } as const;

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <UrgencyBanner />
      <main>
        <SEO
          title="Zonnepanelen & Warmtepompen Elst | SOL-VI Duurzame Energie"
          description="✅ Zonnepanelen, warmtepompen & thuisbatterijen in Gelderland ⚡ Gratis advies & offerte ⭐ 10+ jaar ervaring ☀️ Energieneutraal wonen vanaf €89/maand"
          keywords="zonnepanelen Elst, warmtepomp Gelderland, thuisbatterij Arnhem, duurzame energie, energieneutraal wonen, gratis energieadvies, SOL-VI"
          canonical="https://sol-vi.nl"
          type="website"
          jsonLd={[organization, website, localBusiness] as any}
          preload={[
            { href: heroImage, as: "image" },
            { href: "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap", as: "style" }
          ]}
        />
        <HeroSection />
        <InstantQuoteSection />
        <TrustSignalsBar />
        <ServicesSection />
        <LoxoneSmartHomeSection />
        <AudioPreviewSection />
        <LightingPreviewSection />
        <ClimatePreviewSection />
        <EnergyManagementSection />
        <ZorgeloosSection />
        <EnergyContractsSection />
        <ThermalStorageSection />
        <PartnersSection />
        <TestimonialsSection />
        <CaseStudiesSection />
        <CTASection />
      </main>
      <Footer />
      <FloatingWhatsAppButton />
      <MobileCTABar />
    </div>
  );
};

export default Index;
